import { UserDTO, PasswordStrengthDTO } from './../../api/plyca-dtos';
import { Component, Optional, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { generateRandomIdentifier } from '../../ui.service';
import { HelpService } from '../../components/common/help/help.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TranslateService } from '@ngx-translate/core';
import { UIService } from '../../ui.service';
import { Configuration } from '../../conf/app.constants';
import { AuthService } from '../../auth.service';
import { HttpClient } from '@angular/common/http';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';

@Component({
  selector: 'changePassword',
  templateUrl: 'changePassword.template.html'
})
export class ChangePasswordComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  context: any;


  public formGroup: FormGroup;
  windowHash: string;
  public passConfirm: string;
  public passNew: string;
  public user: UserDTO;

  constructor(
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    protected waitService: WaitLoadingService,
    public helpService: HelpService,
    public translateService: TranslateService,
    public uiService: UIService,
    private _authService: AuthService,
    private configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    private _http: HttpClient,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig) {

    super();
    this.context = this.dialogConfig['user'];
    if (this.dialogConfig['user']) {
      this.user = this.dialogConfig['user'];
    } else {
      this.uiService.showSuccess(
        this.translateService.instant('General.msg.cancel'),
        this.translateService.instant('General.info'),
        'error'
      );
      this.ref.close();
    }

    this.windowHash = generateRandomIdentifier();
  }



  ngAfterContentInit(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.accept',
      'fas fa-lg fa-check',
      'btn btn-primary',
      true, this.windowHash
    ), success => {
      this.updatePassword();
    });

    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fas fa-lg fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.cancel();
    });
    this.waitService.cancelWaiting();
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  isLoaded(): boolean {
    return true;
  }



  cancel(): void {
    this.uiService.showSuccess(
      this.translateService.instant('General.msg.cancel'),
      this.translateService.instant('General.info'),
      'warn'
    );
    this.ref.close();

  }





  public updatePassword() {




    if (!this.passNew
      || !this.passConfirm
      || this.passNew != this.passConfirm) {


      this.uiService.showMessage(
        this.translateService.instant('LoginView.different'),
        this.translateService.instant('General.error'),
        'errorStyle'
      );
    } else {

      this.subscribe(
        this._authService.passwordStrength(this.user.identifier, this.passNew, null),
        (passStrength: PasswordStrengthDTO) => {

          // this.strength = passStrength.strength;
          // this.validPassword = passStrength.valid;
          if (passStrength.valid) {



            let body: any = {
              'user': this.user.identifier,
              'newPassword': this.passNew
            };


            const httpOptions = {
              params: null
            };
            // TODO revisar cambiar por plycaservice simpleUpdate
            let actionUrl = this.configuration.URL_BASE + this.configuration.ADMIN_USER_SERVICE_URL + 'passwords';
            this.waitService.startWaiting();
            this.subscribe(
              this._http.put(actionUrl, JSON.stringify(body), httpOptions),
              () => {
                this.waitService.cancelWaiting();
                this.subscribe(
                  this.uiService.showMessage(this.translateService.instant('UserPrefs.password.success'), this.translateService.instant('General.info')).onClose,
                  () => {
                    this.ref.close();
                  });
              }
              ,
              (error: any) => {
                this.waitService.cancelWaiting();
                this.uiService.showMessage(this.translateService.instant('UserPrefs.password.failure')
                  , this.translateService.instant('General.warn'));
              });

          } else {
            let errorMsg: string;
            if (passStrength.strength) {
              errorMsg = this.translateService.instant('LoginView.' + passStrength.strength);
            } else {
              errorMsg = passStrength.cause;
            }
            //passStrength.strength
            this.uiService.showMessage(errorMsg, this.translateService.instant('General.error'));

          }

        },
        error => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error);
        }
      );


    }

  }
}
